import { createFileRoute } from '@tanstack/react-router';
import Login from '@/pages/Login';

export interface LoginSearch {
  reset?: string;
  redirect?: string;
  signup?: string;
  verified?: string;
  error?: string;
}

export const Route = createFileRoute('/_public/login')({
  validateSearch: (raw: Record<string, unknown>): LoginSearch => ({
    reset: (raw.reset as string) ?? undefined,
    redirect: (raw.redirect as string) ?? undefined,
    signup: (raw.signup as string) ?? undefined,
    verified: (raw.verified as string) ?? undefined,
    error: (raw.error as string) ?? undefined,
  }),
  component: Login,
});
